/**
 * DataBest — Animated background for the login page.
 * tsparticles v4 (ParticlesProvider + Particles). init callback MUST be stable.
 */
import React, { useCallback, useMemo } from "react";
import { Particles, ParticlesProvider } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";

const AnimatedBackground = () => {
    const options = useMemo(
        () => ({
            fullScreen: { enable: false },
            background: { color: "transparent" },
            fpsLimit: 45,
            detectRetina: true,
            particles: {
                number: { value: 42, density: { enable: true, area: 900 } },
                color: {
                    value: ["#A0B8D3", "#52CF88", "#7297BC"],
                },
                links: {
                    enable: true,
                    distance: 140,
                    color: "#A0B8D3",
                    opacity: 0.35,
                    width: 1,
                },
                move: {
                    enable: true,
                    speed: 0.55,
                    random: false,
                    straight: false,
                    outModes: { default: "bounce" },
                },
                opacity: {
                    value: { min: 0.35, max: 0.85 },
                    animation: {
                        enable: true,
                        speed: 0.5,
                        startValue: "random",
                        sync: false,
                    },
                },
                size: { value: { min: 1, max: 2.6 } },
                shape: { type: "circle" },
            },
            interactivity: {
                events: {
                    onHover: { enable: true, mode: "grab" },
                },
                modes: {
                    grab: { distance: 160, links: { opacity: 0.7 } },
                },
            },
        }),
        [],
    );

    // MUST be stable across renders (useCallback with empty deps).
    const init = useCallback(async (engine) => {
        await loadSlim(engine);
    }, []);

    return (
        <div className="pointer-events-none absolute inset-0 overflow-hidden">
            <div className="absolute inset-0 login-bg" />
            <div className="absolute inset-0 mesh-grid opacity-60" />
            <ParticlesProvider init={init}>
                <Particles
                    id="databest-login-particles"
                    options={options}
                    className="absolute inset-0"
                />
            </ParticlesProvider>
            <div
                className="absolute inset-0"
                style={{
                    background:
                        "radial-gradient(circle at 50% 40%, rgba(255,255,255,0.06) 0%, transparent 55%)",
                }}
            />
        </div>
    );
};

export default AnimatedBackground;
